export const SET_FILTERS = "SET_FILTERS";
export const SET_PARSED_FILTERS = "SET_PARSED_FILTERS";
export const SET_PAGES_FILTERS = "SET_PAGES_FILTERS";
export const GET_FILTERS = "GET_FILTERS";
export const GET_FILTERS_SUCCESS = "GET_FILTERS_SUCCESS";
export const RESET_FILTERS = "RESET_FILTERS";
export const RESET_FILTER = "RESET_FILTER";
